// extracted by mini-css-extract-plugin
export default {"header":"PropertiesTable_header__+W38i"};